
import Layout from '../Layout';
import DXCodeBody from '../Component/DXCodeBody';


export default function DXCode() {

 
    return (

        <Layout>
            <DXCodeBody  />
        </Layout>
    )
}